export const NAVIGATION_MENUS = {
  ASSET_UPLOADS_MENU: { key: 'ASSET_UPLOADS_MENU', value: 'Asset uploads' },
  DASHBOARD_MENU: { key: 'DASHBOARD_MENU', value: 'Dashboard' },
  DOCUMENT_MENU_TITLE: { key: 'DOCUMENT_MENU_TITLE', value: 'Documents' },
  EMAIL_MENU_TITLE: { key: 'EMAIL_MENU_TITLE', value: 'Emails' },
  SHORT_MESSAGE_MENU_TITLE: { key: 'SHORT_MESSAGE_MENU_TITLE', value: 'Short Messages' },
  INTERACTIVE_DOCUMENTS_MENU_TITLE: { key: 'INTERACTIVE_DOCUMENTS_MENU_TITLE', value: 'Interactive Documents' },
  SYSTEM_STATS_MENU_TITLE: { key: 'SYSTEM_STATS_MENU_TITLE', value: 'System Stats' },
  ACCOUNT_DETAILS_MENU_TITLE: { key: 'ACCOUNT_DETAILS_MENU_TITLE', value: 'Account Details' },
  DOCUMENT_DASHBOARD_MENU_DESCRIPTION: {
    key: 'DOCUMENT_DASHBOARD_MENU_DESCRIPTION',
    value: 'Shows actionable and useful information at a glance.',
  },
  EMAIL_DASHBOARD_MENU_DESCRIPTION: {
    key: 'EMAIL_DASHBOARD_MENU_DESCRIPTION',
    value: 'Shows actionable and useful information at a glance.',
  },
  SHORT_MESSAGE_DASHBOARD_MENU_DESCRIPTION: {
    key: 'SHORT_MESSAGE_DASHBOARD_MENU_DESCRIPTION',
    value: 'Shows actionable and useful information at a glance.',
  },
  SYSTEM_STATS_DASHBOARD_MENU_DESCRIPTION: {
    key: 'SYSTEM_STATS_DASHBOARD_MENU_DESCRIPTION',
    value: 'Shows actionable and useful information at a glance.',
  },
  DESIGN_SYSTEM_MENU_TITLE: { key: 'DESIGN_SYSTEM_MENU_TITLE', value: 'Design System' },
  DESIGN_INSPIRATION_MENU_TITLE: {
    key: 'DESIGN_INSPIRATION_MENU_TITLE',
    value: 'Inspirations',
  },
  DESIGN_INSPIRATION_MENU_DESCRIPTION: {
    key: 'DESIGN_INSPIRATION_MENU_DESCRIPTION',
    value: 'Get inspired by creative design templates and utilize them in your designs.',
  },
  DOCUMENT_MENU_DESCRIPTION: {
    key: 'DOCUMENT_MENU_DESCRIPTION',
    value:
      'Create and manage all your documents in various environments that can be printed or faxed.',
  },
  EMAIL_MENU_DESCRIPTION: {
    key: 'EMAIL_MENU_DESCRIPTION',
    value: 'Create beautiful looking emails and manage them here.',
  },
  SHORT_MESSAGE_MENU_DESCRIPTION: {
    key: 'SHORT_MESSAGE_MENU_DESCRIPTION',
    value: 'Create and manage all your whatsapp, sms and phone calls in this section.',
  },
  SHORT_MESSAGE_MENU_DESCRIPTION_WHATSAPP_DISABLED: {
    key: 'SHORT_MESSAGE_MENU_DESCRIPTION_WHATSAPP_DISABLED',
    value: 'Create and manage all your sms and phone calls in this section.',
  },
  INTERACTIVE_DOCUMENTS_MENU_DESCRIPTION: {
    key: 'INTERACTIVE_DOCUMENTS_MENU_DESCRIPTION',
    value: 'View the generated documents, make necessary edits, and proceed with final generation.',
  },
  TRANSACTIONS_MENU: { key: 'TRANSACTIONS_MENU', value: 'Transactions' },
  GENERATE_PDF_MENU_TITLE: { key: 'GENERATE_PDF_MENU_TITLE', value: 'Generate PDF' },
  GENERATE_PDF_MENU_DESCRIPTION: {
    key: 'GENERATE_PDF_MENU_DESCRIPTION',
    value:
      'Generate printable pdfs with your customer details through excel upload for all your templates.',
  },
  TRIGGER_EMAIL_MENU_TITLE: { key: 'TRIGGER_EMAIL_MENU_TITLE', value: 'Trigger Emails' },
  TRIGGER_EMAIL_MENU_DESCRIPTION: {
    key: 'TRIGGER_EMAIL_MENU_DESCRIPTION',
    value:
      'Generate personalized beautiful emails and send it to your customers through excel uploads.',
  },
  SEND_WHATSAPP_MENU_TITLE: { key: 'SEND_WHATSAPP_MENU_TITLE', value: 'Send Whatsapp' },
  SEND_WHATSAPP_MENU_DESCRIPTION: {
    key: 'SEND_WHATSAPP_MENU_DESCRIPTION',
    value:
      'Generate personalized whatsapp text messages and deliver it to your customers through excel uploads.',
  },
  SEND_SMS_MENU_TITLE: { key: 'SEND_SMS_MENU_TITLE', value: 'Send SMS' },
  SEND_SMS_MENU_DESCRIPTION: {
    key: 'SEND_SMS_MENU_DESCRIPTION',
    value:
      'Generate personalized text messages and deliver it to your customers through excel uploads.',
  },
  INITIATE_CALL_MENU_TITLE: { key: 'INITIATE_CALL_MENU_TITLE', value: 'Initiate Phone Calls' },
  INITIATE_CALL_MENU_DESCRIPTION: {
    key: 'INITIATE_CALL_MENU_DESCRIPTION',
    value:
      'Generate personalized audio short messages and deliver to your customers through excel uploads.',
  },
  ADMIN_CONFIGURATION_MENU: { key: 'ADMIN_CONFIGURATION_MENU', value: 'Admin configurations' },
  MAIL_ROOM_MENU: { key: 'MAIL_ROOM_MENU', value: 'Mail Room' },
  BILLING_AND_INVOICE_MENU: { key: 'BILLING_AND_INVOICE_MENU', value: 'Billing & Invoices' },
  BILLING_AND_INVOICE_MENU_DESCRIPTION: {
    key: 'BILLING_AND_INVOICE_MENU_DESCRIPTION',
    value:
      'View your current plan, account status, and access billing/payment details and invoices',
  },
  USAGE_MENU_TITLE: { key: 'USAGE_MENU_TITLE', value: 'Usage' },
  USAGE_MENU_DESCRIPTION: {
    key: 'USAGE_MENU_DESCRIPTION',
    value:
    "Monitor your plan's limits and current usage."
  },
  INTEGRATION_KEY_MENU_TITLE: { key: 'INTEGRATION_KEY_MENU_TITLE', value: 'Integration Key'},
  INTEGRATION_KEY_MENU_DESCRIPTION: {
    key: 'INTEGRATION_KEY_MENU_DESCRIPTION',
    value:
    'View and regenerate your API key for seamless integration with third-party systems via APIs'
  },
  MANAGE_BUSINESS_DATA_MENU: {
    key: 'MANAGE_BUSINESS_DATA_MENU',
    value: 'Manage business data',
  },
  MANAGE_DATA_VARIABLES_MENU: {
    key: 'MANAGE_DATA_VARIABLES_MENU',
    value: 'Manage data variables',
  },
  MANAGE_DATA_VARIABLES_MENU_DESCRIPTION: {
    key: 'MANAGE_DATA_VARIABLES_MENU_DESCRIPTION',
    value: 'Create and manage data variables to use across your templates and documents.',
  },
  MANAGE_BUSINESS_CONTRACTS_MENU: {
    key: 'MANAGE_BUSINESS_CONTRACTS_MENU',
    value: 'Manage Business contracts',
  },
  MANAGE_BUSINESS_CONTRACTS_MENU_DESCRIPTION: {
    key: 'MANAGE_BUSINESS_CONTRACTS_MENU_DESCRIPTION',
    value: 'Centrally manage your business data contracts and define how client business system data maps to source variables.',
  },
  CLEAN_UP_STORAGE_MENU: {
    key: 'CLEAN_UP_STORAGE_MENU',
    value: 'Clean Up Storage'
  },
  EMAIL_AUDIT_MENU: { key: 'EMAIL_AUDIT_MENU', value: 'Email Audit' },
  CHANGE_PASSWORD_MENU: { key: 'CHANGE_PASSWORD_MENU', value: 'Change Password' },
  LOGOUT_MENU: { key: 'LOGOUT_MENU', value: 'Logout' },
  SUPPORT_MENU:{ key: 'SUPPORT_MENU', value: 'Support' },
  MENU_TOOLTIP_TEXT: {
    key: 'MENU_TOOLTIP_TEXT',
    value: 'Menu'
  },
  SUPPORT_TOOLTIP_TEXT: {
    key: 'SUPPORT_TOOLTIP_TEXT',
    value: 'Get help here'
  },
  WORKFLOW_MENU: {
    key: 'WORKFLOW_MENU',
    value: 'Workflow'
  },
  HYBRID_MAIL_ROOM_MENU: { key: 'HYBRID_MAIL_ROOM_MENU', value: 'Hybrid Mail Room' },
  ORGANIZATIONS: { key: 'ORGANIZATIONS', value: 'Organizations' },
  MANAGE_ORGANIZATIONS: { key: 'MANAGE_ORGANIZATIONS', value: 'Manage' },
  MANAGE_ORGANIZATIONS_MENU_DESCRIPTION: {
    key: 'MANAGE_ORGANIZATIONS_MENU_DESCRIPTION',
    value: 'Create and control all organizations you own.',
  },
  EXIT_ORGANIZATIONS: { key: 'EXIT_ORGANIZATIONS', value: 'Exit' },
  EXIT_ORGANIZATIONS_MENU_DESCRIPTION: {
    key: 'EXIT_ORGANIZATIONS_MENU_DESCRIPTION',
    value: 'Sign Out of current Organization.',
  },
  SMART_BATCH_STUDIO_TITLE: {
    key: 'SMART_BATCH_STUDIO_TITLE',
    value: 'Smart Batch Studio',
  },
  SMART_BATCH_STUDIO_DESC: {
    key: 'SMART_BATCH_STUDIO_DESC',
    value: 'Upload Excel/XML files to generate bulk documents and deliver emails, trigger hybrid mail, and monitor transaction performance in real time.',
  },
};

export const LANDING_PAGE = {
  LANDING_PAGE_DESCRIPTION_TO_DESIGN: {
    key: 'LANDING_PAGE_DESCRIPTION_TO_DESIGN',
    value: 'Perfect Way To Design',
  },
  LANDING_PAGE_DESCRIPTION: {
    key: 'LANDING_PAGE_DESCRIPTION',
    value: 'Beautiful Correspondences',
  },
  START_DESIGN_BUTTON: {
    key: 'START_DESIGN_BUTTON',
    value: 'START DESIGNING',
  },
  BUTTON_TEXT_PLEASE_WAIT: {
    key: 'BUTTON_TEXT_PLEASE_WAIT',
    value: 'Please wait'
  },
  GO_CREATE_SLOGAN_TEXT_ONE: {
    key: 'GO_CREATE_SLOGAN_TEXT_ONE',
    value: 'Create with control.'
  },
  GO_CREATE_SLOGAN_TEXT_TWO: {
    key: 'GO_CREATE_SLOGAN_TEXT_TWO',
    value: 'Deliver with confidence.'
  },
};

export const START_DESIGNING_MODAL = {
  DESIGN_TITLE: {
    key: 'DESIGN_TITLE',
    value: 'What would you like to design today?',
  },
  DOCUMENT_TITLE: { key: 'DOCUMENT_TITLE', value: 'Document' },
  EMAIL_TITLE: { key: 'EMAIL_TITLE', value: 'Digital Email' },
  SHORT_MESSAGE_TITLE: { key: 'SHORT_MESSAGE_TITLE', value: 'Short Message' },
};

export const ALERT_NOTIFICATION = {
  TRANSACTION_FULL_MESSAGE: {
    key: 'TRANSACTION_FULL',
    value: "Document generation in your account is currently restricted as you've gone beyond your subscribed plan's document generation limit. To regain access to document generation, please consider upgrading your plan or wait until the end of this monthly cycle.",
  },
  EMAIL_TRANSACTION_FULL_ALERT_MESSAGE: {
    key: 'EMAIL_TRASACTION_FULL_ALERT_MESSAGE',
    value: 'You have reached the email sending limit for your current plan. To send more emails, please either upgrade your plan or wait until the next billing cycle starts.'
  },
  STORAGE_FULL_MESSAGE: {
    key: 'STORAGE_FULL_MESSAGE',
    value: "Document generation is currently limited in your account because you've exceeded your subscribed plan's storage quota. To remove these restrictions, please think about either upgrading your plan or freeing up storage space within your account.",
  },
  UPGRADE_PLAN_BUTTON: {
    key: 'UPGRADE_PLAN_BUTTON',
    value: 'Upgrade Plan',
  },
  OR_TEXT: {
    key: 'OR_TEXT',
    value: 'or',
  },
  FREE_UP_STORAGE_LINK: {
    key: 'FREE_UP_STORAGE_LINK',
    value: 'Free Up Storage',
  },
  CONTACT_ADMIN_MESSAGE: {
    key: 'CONTACT_ADMIN_MESSAGE',
    value: 'Contact your admin to upgrade this account'
  },
}

export const SAAS_SETUP_LOADER = {
  LOADING_STATE_ONE: {
    key: 'LOADING_STATE_ONE',
    value: 'Warming up your account!'
  },
  LOADING_STATE_TWO: {
    key: 'LOADING_STATE_TWO',
    value: 'Spinning up your instance'
  },
  LOADING_STATE_THREE: {
    key: 'LOADING_STATE_THREE',
    value: 'Setting up storage - just a couple mins!'
  },
  LOADING_STATE_FOUR: {
    key: 'LOADING_STATE_FOUR',
    value: 'Adding the finishing touches!'
  },
  MODAL_TITLE: {
    key: 'MODAL_TITLE',
    value: 'Setting up your organization',
  },
  SUCCESS_MESSAGE: {
    key: 'SUCCESS_MESSAGE',
    value: 'Your account has been setup successfully!'
  },
  ERROR_MESSAGE: {
    key: 'ERROR_MESSAGE',
    value: 'We were unable to setup your account. Please retry or contact support.'
  },
  RETRY_BUTTON: {
    key: 'RETRY_BUTTON',
    value: 'Retry'
  },
}